import {AfterViewInit, ChangeDetectionStrategy, Component, inject, OnInit, ViewChild} from "@angular/core";
import {
  AbstractThirdPartyComponent,
  BaseControlData,
  ComponentMapper,
  TreeComponent,
  TreeNode
} from "@fgpp-ui/components";
import {TreeViewDirective} from "@fgpp-ui/components";
import {LinkedTreeService} from "./linked-tree.service";
import {SelectionTreeControlData} from "./selection-tree.control-data";
import {SelectionTreeSchema} from "./selection-tree.schema";

@Component({
  selector: 'lib-selection-tree',
  templateUrl: './selection-tree.component.html',
  styleUrls: ['./selection-tree.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [LinkedTreeService]
})
export class SelectionTreeComponent extends AbstractThirdPartyComponent<SelectionTreeControlData> implements AfterViewInit{

  @ViewChild('left') leftTreeDir: TreeViewDirective;
  @ViewChild('right') rightTreeDir: TreeViewDirective;
  leftTree: TreeComponent;
  rightTree: TreeComponent;
  linkedTreeService = inject(LinkedTreeService);
  disabled: boolean;

  ngAfterViewInit() {
    this.leftTree = this.leftTreeDir?.getComponent();
    this.rightTree = this.rightTreeDir?.getComponent();

    this.linkedTreeService.bindTrees(this.leftTree, this.rightTree);
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (Array.isArray(this.controlData.disabled) && this.controlData.disabled.length > 0) {
      this.controlData.rightTree.disabled = ['rightTree'];
      this.controlData.leftTree.disabled = ['leftTree'];
    }
  }

  onTreeSelectionChange(e: TreeNode) {
    // console.log(e);
  }

  moveAllToLeft() {
   this.linkedTreeService.moveAllToLeft();
  }

  moveToLeft() {
    this.linkedTreeService.moveToLeft();
  }

  moveToRight() {
    this.linkedTreeService.moveToRight();
  }

  moveAllToRight() {
    this.linkedTreeService.moveAllToRight();
  }
}

ComponentMapper.registerThirdPartyComponent('selection-tree', SelectionTreeComponent, SelectionTreeSchema);
